module.exports = __webpack_public_path__ + "static/oidenki-a4c662392fe12c087018a9524d3103ef.svg";